import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { focusHeaderPaths } from 'config/focus-header-paths';
import useIsViewport from './useIsViewport';

/**
 * Determines whether the current route should trigger a focused header view,
 * in which specific desktop header links are hidden to reduce distractions.
 */
export function useIsFocusHeaderPath() {
  const isMobile = useIsViewport();
  const location = useLocation();
  const [isFocusHeader, setIsFocusHeader] = useState(false);

  useEffect(() => {
    const currentPath = location.pathname;
    const isMatch = Object.values(focusHeaderPaths).some((getPathFn) => {
      const basePath = getPathFn();
      return currentPath === basePath || currentPath.startsWith(basePath + '/');
    });
    setIsFocusHeader(isMatch);
  }, [location]);

  return isFocusHeader && !isMobile;
}
